// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBySide_wrapper__C0SpV","img":"SideBySide_img__rKnl7"};